import { ProjectInfoData } from '../dto/EntityRepository';
import { UpdateProjectInfoBulkReq, UpdateProjectInfoReq } from '../dto/ReqDtoRepository';
import { toProjectInfoCustomNameReq, toProjectInfoValuesReq } from './projectInfo';

export const toUpdateProjectInfoItemReq = (pi: ProjectInfoData): UpdateProjectInfoReq => ({
  id: pi.id,
  type: pi.type,
  customName: toProjectInfoCustomNameReq(pi.customName),
  customValues: toProjectInfoValuesReq(pi.type, pi.customValues),
});

/** hasChanged인 항목만 모은다. 없으면 null (빈 piList는 API 400). */
export const toUpdateProjectInfoBulkReq = (
  projectId: string,
  projectInfoList: ProjectInfoData[],
): UpdateProjectInfoBulkReq | null => {
  const piList = projectInfoList
    .filter((pi) => pi.hasChanged)
    .map(toUpdateProjectInfoItemReq);
  if (piList.length === 0) return null;
  return { projectId, piList };
};
